/**
 * StatsD c method name
 * @type {String}
 */
export const COUNT = 'count';

/**
 * StatsD ms method name
 * @type {String}
 */
export const TIME = 'time';

/**
 * StatsD g method name
 * @type {String}
 */
export const GAUGE = 'gauge';

/**
 * StatsD s method name
 * @type {String}
 */
export const SET = 'set';

/**
 * StatsD h method name
 * @type {String}
 */
export const HISTOGRAM = 'histogram';

/**
 * List of StatsD method types
 * @type {Array}
 */
export const TYPES = [ COUNT, TIME, GAUGE, SET, HISTOGRAM ];
